<div class="modal-header">
  <h4 class="modal-title pull-left">{{'REFERENTIEL_WORKFLOW.MODELE_WORKFLOW' | translate}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="showModalCancel()"
    title="{{'GLOBAL.FERMER' | translate}}">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row" [ngClass]="etapeObligatoire? 'class1' : 'class2'">
    <div class="col-lg-6 col-md-6">
      <form id="myForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="nomWorkflow">{{'GLOBAL.NOM' | translate}}</label>
          <input id="nomWorkflow" type="text" [(ngModel)]="workflowModele.nom" name="nomWorkflow" class="form-control"
            placeholder="{{'GLOBAL.NOM' | translate}}" maxlength="50" />
            @if (nomInvalide) {
              <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
            }
          </div>
          @if (estMiseJour) {
            <div>{{'GLOBAL.DATE_MODIFICATION' | translate}} : {{workflowModele.dateDerniereModification
            | date: 'dd/MM/yyyy'}}</div>
          }
        </form>
      </div>
      <div class="col-lg-6 col-md-6">
        <label for="workflowEtapeModeles">{{'REFERENTIEL_WORKFLOW.ETAPES' | translate}}</label>
        <div class="container-etapes">


          <!-- STEP CARD -->
          <ng-template #itemTemplate let-item="item" let-index="index">
            <div draggable="false" class="etape d-flex justify-content-between">
              <div class="autorisation-radios-box">
                <!-- RADIOS BTN'S -->
                <div class="radio-box" style="z-index: 10;background: white;">
                  <form action="">
                    <label>
                      <input type="radio" [value]="0"
                        [(ngModel)]="workflowModele.workflowEtapeModeles[index].accessPermission" name="accessPermission"
                        id="none"> none
                      </label>

                      <label>
                        <input type="radio" [value]="1"
                          [(ngModel)]="workflowModele.workflowEtapeModeles[index].accessPermission" name="accessPermission"
                          id="read"> read
                        </label>

                        <label>
                          <input type="radio" [value]="2"
                            [(ngModel)]="workflowModele.workflowEtapeModeles[index].accessPermission" name="accessPermission"
                            id="read-write"> read-write
                          </label>
                        </form>
                      </div>
                    </div>
                    <i class="fas fa-arrows-alt" style="color: #ced4da;"></i>
                    <textarea [(ngModel)]="workflowModele.workflowEtapeModeles[index].nom"
                      name="{{'nomEtape' + index}}" class="text-etape" (dragstart)="disableDrag($event)"
                    maxlength="30"></textarea>
                    <div class="workflow-etape-trash"><i class="fas fa-times" (click)="deleteItem(item.value)"></i></div>
                  </div>
                  @if (index < workflowModele.workflowEtapeModeles.length -1) {
                    <div class="fleche-etapes">
                      <i class="fas fa-arrow-down"></i>
                    </div>
                  }
                </ng-template>
                <bs-sortable [(ngModel)]="workflowModele.workflowEtapeModeles" name="workflowEtapeModeles"
                  [itemTemplate]="itemTemplate" itemClass="sortable-item" itemActiveClass="sortable-item-active"
                  #sortableComponent wrapperClass="sortable-wrapper">
                </bs-sortable>
              </div>
              <div id="erreurEtape" [ngClass]="etapeNomObligatoire ? 'erreur-etape-marge' : ''">
                @if (etapeNomObligatoire) {
                  <div class="custom-alert custom-alert-sm">
                    {{'REFERENTIEL_WORKFLOW.ETAPES_NOM_OBLIGATOIRE' | translate}}
                  </div>
                }
              </div>
              <form id="form-etape" class="input-group mb-3" (ngSubmit)="addEtape()">
                <input type="text" class="form-control" placeholder="{{'REFERENTIEL_WORKFLOW.AJOUTER_ETAPES' | translate}}"
                  [(ngModel)]="nomEtapeToAdd" id="nomEtapeToAdd" name="nomEtapeToAdd" aria-describedby="button-add"
                  maxlength="50">
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary" type="submit" id="button-addon2"><i
                    class="fas fa-check"></i></button>
                  </div>
                  @if (etapeObligatoire) {
                    <div class="custom-alert custom-alert-sm">
                      {{'REFERENTIEL_WORKFLOW.ETAPES_OBLIGATOIRE' | translate}}
                    </div>
                  }
                </form>
              </div>
            </div>
            @if (erreurApi) {
              <div class="custom-alert custom-alert-sm">{{'GLOBAL.ERREUR_MAJ_API' | translate }}</div>
            }
            <div class="btn-toolbar justify-content-between">
              <div class="btn-group" role="group">
                <button type="submit" class="btn btn-outline-success" style="margin-right:10px;"
                (click)="onSubmit()">{{'GLOBAL.VALIDER' | translate}}</button>
                @if (estMiseJour) {
                  <button type="button" class="btn btn-danger" (click)="showModalSuppr()">{{'GLOBAL.SUPPRIMER' |
                  translate}}</button>
                }
              </div>
              <div class="btn-group" role="group">
                @if (estRegion) {
                  <button type="button" class="btn btn-outline-success"
                  (click)="showModalApplyToAll()">{{'WORKFLOW.APPLY_TO_ALL' | translate}}</button>
                }
              </div>
              <div class="btn-group" role="group">
                <button type="button" class="btn btn-secondary" (click)="showModalCancel()">{{'GLOBAL.FERMER' |
                translate}}</button>
              </div>
            </div>
          </div>




          <div bsModal #modalConfirmSuppr="bs-modal" class="modal fade" tabindex="-1" role="dialog"
            aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
            <div class="modal-dialog modal-sm">
              <div class="modal-content">
                <div class="custom-overlay"></div>
                <div class="modal-body text-center">
                  <p>{{'GLOBAL.CONFIRMATION_SUPPRESSION' | translate}}</p>
                  <button type="button" class="btn btn-primary" (click)="delete()">{{'GLOBAL.OUI' | translate}}</button>
                  <button type="button" class="btn btn-secondary" (click)="annulSuppr()" style="margin-left: 20px;">{{'GLOBAL.NON'
                  | translate}}</button>
                </div>
              </div>
            </div>
          </div>

          <div bsModal #modalConfirmCancel="bs-modal" class="modal fade" tabindex="-1" role="dialog"
            aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
            <div class="modal-dialog modal-sm">
              <div class="modal-content">
                <div class="custom-overlay"></div>
                <div class="modal-body text-center">
                  <p>{{'GLOBAL.CONFIRMATION_ANNULATION' | translate}}</p>
                  <button type="button" class="btn btn-primary" (click)="annulModif()">{{'GLOBAL.OUI' | translate}}</button>
                  <button type="button" class="btn btn-secondary" (click)="modalConfirmCancel.hide()"
                  style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
                </div>
              </div>
            </div>
          </div>

          <div bsModal #modalConfirmApply="bs-modal" class="modal fade" tabindex="-1" role="dialog"
            aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
            <div class="modal-dialog modal-sm">
              <div class="modal-content">
                <div class="custom-overlay"></div>
                <div class="modal-body text-center">
                  <p>{{'WORKFLOW.WARNING_APPLY' | translate}}</p>
                  <button type="button" class="btn btn-primary" (click)="ApplyWorkflowToAll()">{{'GLOBAL.OUI' |
                  translate}}</button>
                  <button type="button" class="btn btn-secondary" (click)="modalConfirmApply.hide()"
                  style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
                </div>
              </div>
            </div>
          </div>